<section>
    <section class="register-holder">
        <form [formGroup]="registerForm">
            <section class="register-form-holder">
                <mat-form-field>
                    <input matInput placeholder="Name" formControlName="name">
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Email" formControlName="email">
                </mat-form-field>
                <mat-form-field>
                    <input matInput type="password" placeholder="Password" formControlName="password">
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="register()">Register</button>
                <section>
                    {{errorMessage}}
                </section>
            </section>
        </form> 
        <section><a routerLink="/">Login</a></section>
    </section>
   
</section>